<template>
  <div class="card">
    <div class="flex justify-content-between align-items-center mb-4">
      <h2>Tipos de Merma</h2>
      <Button label="Nuevo Tipo" icon="pi pi-plus" class="p-button-success" @click="abrirModalNuevo" v-if="auth && 'Tipo Merma Crear' in auth.user.permissions" />
    </div>

    <!-- Tabla de Listado Reutilizable -->
    <CustomDataTable
      :datos="tiposMerma"
      :columnas="columnas"
      :cargando="cargando"
      nombreEntidad="tipos de merma"
      dataKey="id"
    >
      <!-- Slot dinámico para Estado -->
      <template #estado="{ data }">
        <span :class="'product-badge ' + (data.estado == 1 ? 'status-instock' : 'status-outofstock')">
          {{ data.estado == 1 ? 'Activo' : 'Inactivo' }}
        </span>
      </template>
      
      <!-- Slot para Acciones -->
      <template #acciones="{ data }">
        <Button icon="pi pi-pencil" class="p-button-rounded p-button-warning p-button-text" @click="editarTipo(data)" v-if="auth && 'TipoMerma Editar' in auth.user.permissions" />
        <Button icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-text" @click="confirmarEliminar(data)" v-if="auth && 'TipoMerma Eliminar' in auth.user.permissions" />
      </template>
    </CustomDataTable>

    <!-- Modal para Crear/Editar -->
    <ZapiModalShell
      v-model:visible="mostrarModal"
      :title="modoEdicion ? 'Editar Tipo de Merma' : 'Nuevo Tipo de Merma'"
      width="450px"
      @confirm="guardarTipo"
      class="p-fluid"
    >
      <div class="field mt-3">
        <label for="descripcion">Descripción</label>
        <Textarea id="descripcion" v-model="tipoActual.descripcion" required="true" rows="3" cols="20" />
      </div>
      <div class="field mt-3">
        <label for="estado">Estado</label>
        <Dropdown
          id="estado"
          v-model="tipoActual.estado"
          :options="[{ label: 'Activo', value: 1 }, { label: 'Inactivo', value: 0 }]"
          optionLabel="label"
          optionValue="value"
          :disabled="!modoEdicion"
        >
          <template #value="slotProps">
            <span v-if="slotProps.value !== null" :class="'product-badge ' + (slotProps.value == 1 ? 'status-instock' : 'status-outofstock')">
              {{ slotProps.value == 1 ? 'Activo' : 'Inactivo' }}
            </span>
          </template>
          <template #option="slotProps">
            <span :class="'product-badge ' + (slotProps.option.value == 1 ? 'status-instock' : 'status-outofstock')">
              {{ slotProps.option.label }}
            </span>
          </template>
        </Dropdown>
      </div>
    </ZapiModalShell>

    <!-- Modal Confirmar Eliminar -->
    <ZapiModalShell
      v-model:visible="deleteTipoMermaDialog"
      title="Confirmar"
      width="450px"
      @confirm="deleteTipoMerma"
    >
      <div class="flex align-items-center justify-content-center">
        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
        <p v-if="tipoActual"
          ><strong>Estás Seguro de Eliminar el Tipo de Merma: </strong>
          <b>{{ tipoActual.descripcion }} ?</b></p
        >
      </div>
      <template #footer>
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-success p-button-lg"
          @click="deleteTipoMermaDialog = false"
        />
        <Button
          label="Si Eliminar"
          icon="pi pi-check"
          class="p-button-danger p-button-lg"
          @click="deleteTipoMerma"
        />
      </template>
    </ZapiModalShell>
  </div>
</template>

<script>
import CustomDataTable from '@/components/shared/CustomDataTable.vue';
import ZapiModalShell from '@/components/shared/ZapiModalShell.vue';
import TipoMermaService from '@/service/TipoMermaService';
import { useAuth } from '@/stores';

export default {
  name: 'TipoMermaList',
  components: { CustomDataTable, ZapiModalShell },
  data() {
    return {
      columnas: [
        { field: 'id', header: 'ID', sortable: true },        
        { field: 'descripcion', header: 'Descripción', sortable: false },
        { field: 'estado', header: 'Estado', sortable: true }
      ],
      tiposMerma: [],
      cargando: false,
      mostrarModal: false,
      deleteTipoMermaDialog: false,
      modoEdicion: false,
      enviado: false,
      tipoActual: {
        id: null,        
        descripcion: '',
        estado: 1
      }
    };
  },
  auth: null,
  created() {
    this.auth = useAuth();
    this.tipoMermaService = new TipoMermaService();
  },
  mounted() {
    this.cargarDatos();
  },
  methods: {
    async cargarDatos() {
      this.cargando = true;
      try {
        const response = await this.tipoMermaService.getAll();
        this.tiposMerma = response.data || response;
      } catch (error) {
        console.error("Error al cargar datos", error);
        this.$toast.add({severity:'error', summary: 'Error', detail: 'No se pudieron cargar los datos', life: 3000});
      } finally {
        this.cargando = false;
      }
    },
    abrirModalNuevo() {
      this.tipoActual = { id: null, descripcion: '', estado: 1 };
      this.enviado = false;
      this.modoEdicion = false;
      this.mostrarModal = true;
    },
    cerrarModal() {
      this.mostrarModal = false;
      this.enviado = false;
    },
    editarTipo(tipo) {
      this.tipoActual = { ...tipo }; // Clonamos el objeto
      this.modoEdicion = true;
      this.mostrarModal = true;
    },
    async guardarTipo() {
      this.enviado = true;
      
      if (this.tipoActual.descripcion && this.tipoActual.descripcion.trim()) {
        try {
          if (this.modoEdicion) {
            const response = await this.tipoMermaService.update(this.tipoActual);
            const dataActualizada = response.data || response || this.tipoActual;
            
            const index = this.tiposMerma.findIndex(t => t.id === this.tipoActual.id);
            if (index !== -1) {
              this.tiposMerma.splice(index, 1, dataActualizada); // Actualizar en el array local
            }
            this.$toast.add({severity:'success', summary: 'Éxito', detail: 'Tipo de merma actualizado', life: 3000});
          } else {
            const response = await this.tipoMermaService.create(this.tipoActual);
            const dataNueva = response.data || response;
            
            // Si el backend no devuelve el id, o devuelve algo incompleto, lo manejas aquí
            // Usualmente el backend devuelve el objeto completo creado.
            this.tiposMerma.push(dataNueva); // Agregar al array local
            this.$toast.add({severity:'success', summary: 'Éxito', detail: 'Tipo de merma creado', life: 3000});
          }
          this.cerrarModal();
        } catch (error) {
          console.error("Error al guardar", error);
          this.$toast.add({severity:'error', summary: 'Error', detail: 'Ocurrió un error al guardar', life: 3000});
        }
      }
    },
    async confirmarEliminar(tipo) {
      this.tipoActual = { ...tipo };
      this.deleteTipoMermaDialog = true;
    },
    async deleteTipoMerma() {
      try {
        await this.tipoMermaService.delete(this.tipoActual.id);
        this.tiposMerma = this.tiposMerma.filter(t => t.id !== this.tipoActual.id); // Quitar localmente
        this.$toast.add({severity:'success', summary: 'Éxito', detail: 'Tipo de merma eliminado', life: 3000});
        this.deleteTipoMermaDialog = false;
        this.tipoActual = { id: null, descripcion: '', estado: 1 };
      } catch (error) {
        console.error("Error al eliminar", error);
        this.$toast.add({severity:'error', summary: 'Error', detail: 'Ocurrió un error al eliminar', life: 3000});
      }
    },
    // (Eliminamos getSeverity ya que lo hacemos directo en el template)
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/demo/badges.scss";

.card {
  padding: 1.5rem;
  background-color: var(--surface-card);
  border-radius: 10px;
  box-shadow: 0 2px 1px -1px rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 1px 3px 0 rgba(0,0,0,.12);
}
</style>
